export const withIdTag = (type, id) => (id ? [{ type, id }, type] : [type])
